// @ts-nocheck

import type { OverlayState } from '../states/overlay';
import { OverlayStateActionTypes } from '../types/actions/overlay';

export const overlayInitialState: OverlayState = {
  animationId: undefined,
};

export default (state: OverlayState = overlayInitialState, action: unknown) => {
  switch (action.type) {
    case OverlayStateActionTypes.PLAY_ANIMATION: {
      const { animationId } = action.payload ?? {};
      return {
        ...state,
        animationId: animationId,
      };
    }
    case OverlayStateActionTypes.STOP_ANIMATION: {
      return {
        ...state,
        animationId: undefined,
      };
    }
    default:
      return state;
  }
};
